var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaceook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 768 768",
    style: {
      enableBackground: "new 0 0 768 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0181AE",
    d: "M609.8,154.1C549.5,93.8,469.3,60.6,384,60.6c-85.3,0-165.5,33.2-225.8,93.5c-60.3,60.3-93.5,140.5-93.5,225.8 c0,85.3,33.2,165.5,93.5,225.8c60.3,60.3,140.5,93.5,225.8,93.5c85.3,0,165.5-33.2,225.8-93.5c60.3-60.3,93.5-140.5,93.5-225.8 C703.3,294.6,670.1,214.4,609.8,154.1z M384,648.8c-148.3,0-269-120.7-269-269s120.7-269,269-269s269,120.7,269,269 S532.3,648.8,384,648.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0181AE",
    d: "M499,465.2l13.1-85.4h-81.9v-55.4c0-23.4,11.4-46.1,48.1-46.1h37.3v-72.7c0,0-33.8-5.8-66.1-5.8 c-67.5,0-111.6,40.9-111.6,114.9v65.1h-75v85.4h75v206.4c15,2.4,30.4,3.6,46.2,3.6c15.7,0,31.1-1.2,46.2-3.6V465.2H499z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaceook);
export default __webpack_public_path__ + "static/media/iconFaceook.1f86041acd3ab1972a8876c0d46fec4c.svg";
export { ForwardRef as ReactComponent };